import React from "react";
import "./card-rates-description.scss";
import { navigate } from "gatsby";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
interface CardInterfaceDescription {
  datas: any;
  login: any;
  gigyaAccount: any;
  onClose: any;
  setBanderaLog: any;
  isSpecial?: boolean;
}
const icon_right = require("../../../assets/images/icons/Icon-right.svg");
const CardRatesDescription = (props: CardInterfaceDescription) => {
  const { login, gigyaAccount, onClose, setBanderaLog } = props;
  const value = props.datas;
  return (
    <div>
      <div className="m-share-modal__container__cardbody__internal">
        <div className="m-share-modal__container__cardbody__internal__image">
          <img
            src={value.imagenPrincipal[0].file.url}
            alt={value.imagenPrincipal[0].title}
          />
        </div>
        <div className="m-share-modal__container__cardbody__internal__text">
          <h4>{value.tituloBanner}</h4>
          <p>
            {JSON.parse(
              value?.descripcion?.raw?.content[0]?.content?.[0]?.value
            )}
          </p>
        </div>
        <div
          className={`m-share-modal__container__cardbody__internal__button gtmRedDeAmorEscogerasHoy${normalizeTwoWords(
            value.tituloBanner
          )}`}
          onClick={() => {
            if (gigyaAccount) {
              if (value.tituloDescripcion) {
                localStorage.setItem(
                  "selected-service-id",
                  value.tituloDescripcion
                );
              }

              navigate(value.redireccionBoton);
              onClose(false);
            } else {
              setBanderaLog(true);
              login();
              onClose(false);
            }
          }}
        >
          <div
            className={`ver-mas gtmRedDeAmorEscogerasHoy${normalizeTwoWords(
              value.tituloBanner
            )}  `}
          >
            <p
              className={`gtmRedDeAmorEscogerasHoy${normalizeTwoWords(
                value.tituloBanner
              )}`}
            >
              {value.tituloBoton ? value.tituloBoton : "SABER MÁS"}
            </p>
            <div
              className={`ver-mas-imagen  gtmRedDeAmorEscogerasHoy${normalizeTwoWords(
                value.tituloBanner
              )}  `}
            >
              <img
                src={icon_right}
                alt={"ir a servicios"}
                className={`gtmRedDeAmorEscogerasHoy${normalizeTwoWords(
                  value.tituloBanner
                )}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardRatesDescription;
